const routes = {
  path: 'shelter',
  component: () => import('@/modules/obu-shelter/index.vue'),
  children: [
    {
      path: '',
      name: 'obu-shelter-list',
      component: () => import('@/modules/obu-shelter/ObuShelterList.vue')
    },
    {
      path: ':id',
      name: 'obu-shelter-details',
      component: () => import('@/modules/obu-shelter/ObuShelterDetails.vue'),
      children: [
        {
          path: '',
          name: 'obu-shelter-summary',
          component: () => import('@/modules/obu-shelter/ObuShelterDetailsSummary.vue')
        },
        {
          path: 'links',
          name: 'obu-shelter-backlinks',
          component: () => import('@/modules/obu-shelter/ObuShelterDetailsBacklinks.vue')
        },
        {
          path: 'disavow/domains',
          name: 'obu-shelter-disavow-domains',
          component: () => import('@/modules/obu-shelter/ObuShelterDetailsDisavow.vue')
        },
        {
          path: 'disavow/urls',
          name: 'obu-shelter-disavow-urls',
          component: () => import('@/modules/obu-shelter/ObuShelterDetailsDisavow.vue')
        }
      ]
    }
  ]
}

export default routes
